@if (university$ | async; as university) {
	<!-- On Mobile -> show the tabs at the top of the screen -->
	<div class="sticky top-0 z-50 sm:hidden">
		<uc-navigation-tabs
			[postExclusive]="clientFeatures.isPostExclusive"
			[selectedTab]="subdirectory"
			[isPreview]="isPreview"
			[uniSlug]="university.slug"
		/>
	</div>
	<ng-container *ucRemoveDuplicateDomElement="'hideOnMobile'">
		@if (university) {
			<uc-university-header
				[logo]="university.logo"
				[uniName]="university.name"
				[saved]="university.saved"
				[id]="university.id"
				[delta]="1"
				[ugSearchOrderPosition]="university.order"
				[cleSearchOrderPosition]="null"
				[product]="product"
			>
				<uc-university-header-title
					headerTitle
					[name]="university.name"
					[recommendedPercentage]="university.stats.recommended_percentage"
					[paidFeatures]="university.paid_features"
					[subdirectory]="subdirectory"
					[product]="product"
					[slug]="university.slug"
					[uniId]="university.id"
				/>
				@if (clientFeatures.isFeatured && subdirectory === 'reviews') {
					<div
						ctaButtons
						class="w-full pb-8 sm:flex sm:gap-3 sm:pb-0 sm:max-w-max"
					>
						<uc-visit-website-btn
							customStyles="sm:hidden w-full mb-4"
							[externalUrl]="externalLink()"
							[product]="product"
							componentName="Profile Header"
							[uniId]="university?.id!"
							buttonText="Visit Website"
							sourceType="uni"
							[source]="university?.name!"
							[uniName]="university.name"
							[ugSearchOrderPosition]="university.order"
						/>
						<uc-prospectus-btn
							[params]="university.id"
							customStyles="w-full sm:max-w-max mr-0"
							[link]="externalProspectusLink()"
							componentName="Profile Header"
							[product]="null"
							[privacyPolicyUrl]="university.privacy_policy_url"
							[isFeaturedPostgraduate]="
								clientFeatures.postgraduate || clientFeatures.postPreview
							"
							[isFeaturedUndergraduate]="
								clientFeatures.undergraduate ||
								clientFeatures.underPreview
							"
							[showModal]="true"
							[ugSearchOrderPosition]="university.order"
						/>
						<uc-request-btn
							customStyles="w-full sm:max-w-max"
							[params]="university.id"
							componentName="Profile Header"
							[product]="null"
							[ugSearchOrderPosition]="university.order"
						/>
					</div>
				}
				<!-- Desktop -->
				<div navigation class="flex items-center justify-between sm:border-t">
					<uc-navigation-tabs
						[postExclusive]="clientFeatures.isPostExclusive"
						[selectedTab]="subdirectory"
						[isPreview]="isPreview"
						[uniSlug]="university.slug"
					/>
				</div>
			</uc-university-header>
		}
	</ng-container>
}

<router-outlet />
